import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import NavBar from "./components/NavBar/NavBar";
import { Footer } from "./components/Footer/Footer";
import Contact from "./Pages/Contact";
import AboutUs from "./Pages/AboutUs";
import Home from "./Pages/Home";
import Products from "./Pages/Products";
import Teams from "./Pages/Teams";
import Advantages from "./Pages/Advantages";
import Videos from "./Pages/Videos";
import Services from "./Pages/Services";
import Successs from "./Pages/Successs";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <NavBar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/products" element={<Products />} />
          <Route path="/ourteam" element={<Teams />} />
          <Route path="/advantage" element={<Advantages/>}/>
          <Route path="/video" element={<Videos/>}/>
          <Route path="/services" element={<Services />} />
          <Route path="/success" element={<Successs />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
